import { z } from "zod";
import { AVAILABILITY_STATUSES, SIGNUP_STATUSES } from "@/functions-shared/offer/offerStatusEnums";

/**
 * The two status fields every admin session form validates (KB-4101), built from the one enum module.
 * A stored legacy value (`su_waitlist`, `av_open`) fails here with a message beside its own field,
 * so a human picks a real value rather than the form re-saving the old one.
 */
export const signupStatusSchema = z.enum(SIGNUP_STATUSES, {
  message: "Pick a registration status from the list — the current value is not a valid one.",
});

export const availabilityStatusSchema = z.enum(AVAILABILITY_STATUSES, {
  message: "Pick an availability status from the list — the current value is not a valid one.",
});
